import styled from '@emotion/styled'
import { Tooltip } from 'components/Tooltip'
import { Text } from 'components/Typography'
import { pxToRem } from 'utils/styled'
import { Button } from 'components/button/Button'
import { colors } from 'utils/colors'

export const SWizardGridCardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const SWarningText = styled(Tooltip)`
  margin-left: 0.5rem;
  max-width: unset;
  white-space: nowrap;
  display: none;
`

export const SWarningContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 1.5rem;
  height: 1.5rem;
  z-index: 2;
  transform: translate(30%, -30%);

  &:hover {
    & ${SWarningText} {
      display: inline-block;
    }
  }

  & > svg {
    width: 100%;
    height: 100%;
  }
`

export const SSecondaryButton = styled(Button)`
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-color: ${colors.blue[100]};
  min-height: ${pxToRem(136)}rem;
  text-align: left;

  & > span {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: start;

    grid-template-columns: 100%;
  }
`

export const SWizardGridCardHeader = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-bottom: auto;
  width: 100%;
`

export const SWizardGridCardImage = styled.span`
  width: 1.375rem;
  height: 1.375rem;
  margin-right: 0.5rem;

  & > img,
  & > svg {
    object-fit: contain;
    object-position: center;
    width: 100%;
    max-height: 100%;
  }
`

export const SWizardGridCardTitle = styled(Text)<{ noLineClamp?: boolean }>`
  flex: 1;
  color: ${colors.black};
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${(props) => (props.noLineClamp ? 'unset' : 2)};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`

export const SWizardGridCardSubtitle = styled(Text)`
  font-size: 0.8125rem;
  line-height: 1.25rem;
  white-space: pre-wrap;
  font-weight: normal;
`

export const SWizardGridCardShareWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  align-self: end;
`

export const SWizardGridCardShareArea = styled.div`
  display: inline-flex;
`

export const SWizardGridCardShareItem = styled.span`
  width: ${pxToRem(40)}rem;
  height: ${pxToRem(40)}rem;
  background: var(--c-gray300);
  border: 1px solid var(--c-blue100);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--c-gray500);
  font-family: var(--f-text);
  font-size: ${pxToRem(17)}rem;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
`

export const SWizardGridLockedWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 1rem;
  background: var(--c-gray300-transparent);
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  cursor: pointer;
`

export const SAddButton = styled(Button)`
  width: 100%;
  height: 100%;

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`
